import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

const EventCardLoading = () => (
  <Card dataTestId="eventCardLoading-skeleton" p={0} height="100%">
    <SkeletonWrapper height={{ _: 170, m: 149, l: 157, xl: 168 }} />
    <Box px={4} pt={4} pb={6} flexDirection="column">
      <Box>
        <Skeleton width={42} height={42} mr={3} />
        <Box flexDirection="column" flex={1}>
          <Skeleton width="100%" mt={2} />
          <Skeleton width="75%" mt={2} />
        </Box>
      </Box>
      <Box mt={6} flexDirection="column">
        <Skeleton width="100%" mt={2} />
        <Skeleton width="100%" mt={2} />
      </Box>
    </Box>
  </Card>
);

export default EventCardLoading;

const SkeletonWrapper = styled(Skeleton)`
  border-top-left-radius: ${({ theme }) =>
    `${theme.themeVariables.globalBorderRadius}px`};
  border-top-right-radius: ${({ theme }) =>
    `${theme.themeVariables.globalBorderRadius}px`};
`;
